type Listener = () => void;

const listeners = new Set<Listener>();
let granted = false;

export function hasNativeSession(): boolean {
  return granted;
}

export function grantNativeSession(): void {
  granted = true;
  for (const listener of listeners) {
    listener();
  }
}

export function revokeNativeSession(): void {
  granted = false;
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeNativeSession(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
